import styles from './SubNav.module.scss'

const SubNav = ({ children, ...props }) => {
    return (
        <div className={styles.subNav} {...props}>
            {children}
        </div>
    )
}
export default SubNav
